export const holidayNameOptions = [
  { id: '1', value: 'Cesar Chavez Day', label: 'Cesar Chavez Day' },
  { id: '2', value: 'Friday after ', label: 'Friday after' },
  { id: '3', value: 'Thanksgiving', label: 'Thanksgiving' },
  {
    id: '4',
    value: "Indigenous People's Day",
    label: "Indigenous People's Day",
  },
  { id: '5', value: "New Year's Day", label: "New Year's Day" },
  { id: '6', value: "Presidents' Day", label: "Presidents' Day" },
  { id: '7', value: "Presidents' Day", label: "Presidents' Day" },
  {
    id: '8',
    value: "Martin Luther King Jr.'s Birthday",
    label: "Martin Luther King Jr.'s Birthday",
  },
  { id: '9', value: 'Veterans Day', label: 'Veterans Day' },
  { id: '10', value: 'Independence Day', label: 'Independence Day' },
  { id: '11', value: 'Labor Day', label: 'Labor Day' },
  { id: '12', value: 'Memorial Day', label: 'Memorial Day' },
  { id: '13', value: 'Christmas', label: 'Christmas' },
];
